module.exports = __webpack_public_path__ + "static/p9-ae8b0a147e9a5994a830639f1beb116a.png";